export const updateSuccess = 'Updated editing company name!';
export const updateError = 'Error updating editing company!';
export const companyNamePlaceholder = 'Name...';
export const companyEmailPlaceholder = 'Email...';
export const companyPhoneNumberPlaceholder = 'Phone number...';
